import ChallengeGoalSummary from './ChallengeGoalSummary';

export default ChallengeGoalSummary;
